import { createContext, useContext, useState } from "react";

const TestDriveContext = createContext();

export const TestDriveProvider = ({ children }) => {
  const [showPopup, setShowPopup] = useState(false);

  const openPopup = () => setShowPopup(true);
  const closePopup = () => setShowPopup(false);

  return (
    <TestDriveContext.Provider value={{ showPopup, openPopup, closePopup }}>
      {children}
    </TestDriveContext.Provider>
  );
};

export const useTestDrive = () => useContext(TestDriveContext);
